import React, { useState } from "react";
import { useHistory, Link } from "react-router-dom";

import Sidebar from "../Sidebar";

import MenuIcon from "@material-ui/icons/Menu";
import { IconButton } from "@material-ui/core";

import "./style.css";

function Navbar({ workRef }) {
  const [showSidebar, setShowSidebar] = useState(false);

  const history = useHistory();

  const handleBurgerMenuClick = () => {
    setShowSidebar(!showSidebar);
  };

  const handleSidebarClick = (val) => {
    setShowSidebar(false);
    switch (val) {
      case "home": {
        if (window.location.pathname === "/") {
          window.scrollTo(0, 0);
        } else {
          history.push("/");
          window.scrollTo(0, 0);
        }
        break;
      }
      case "work": {
        if (window.location.pathname === "/") {
          workRef.current.scrollIntoView();
        } else {
          history.push("/?view=work");
        }
        break;
      }
      case "meet": {
        if (window.location.pathname === "/contact") {
          window.scrollTo(0, 0);
        } else {
          history.push("/contact");
          window.scrollTo(0, 0);
        }
        break;
      }
      default: {
        break;
      }
    }
  };

  return (
    <div className="navbar">
      <Link to="/">
        <h3 className="navbar__logo">Surya Mahla</h3>
      </Link>
      <IconButton
        onClick={handleBurgerMenuClick}
        className="navbar__menu__icon__container"
      >
        <MenuIcon className="navbar__menu__icon" />
      </IconButton>

      <Sidebar
        showSidebar={showSidebar}
        handleSidebarClick={handleSidebarClick}
      />
    </div>
  );
}

export default Navbar;
